import React from "react";
import dynamic from "next/dynamic";
const Section = dynamic(() => import("@/Components/LayoutComponents/Section"),{ssr: true});
const QuoteForm = dynamic(() => import("./QuoteForm"), {
  ssr: false,
});

interface RFPFormProps {
  data?: any;
}

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

const RFPForm: React.FC<RFPFormProps> = ({ data }) => {
  return (
    <Section>
      <div className="container">
        <div className="max-w-[1230px] mx-auto text-center">
          <h2 className="text-heading-1 text-primary-text font-bold capitalize">
            {data?.title ?? ""}
          </h2>
          <p className="text-subtitle-2 text-secondary-text font-regular mt-3">
            {data?.form_title ?? ""}
          </p>
        </div>
        <div className="xl:mt-10 mt-[20px] sm:w-auto w-full">
          <div className="flex sm:flex-row flex-col justify-center items-center gap-[30px] mb-[40px] sm:w-auto w-full">
            {/* Blue Card */}
            {data?.buttons?.[0]?.href && (
              <div className="h-full flex items-center justify-center cursor-pointer sm:w-auto w-full">
                <div
                  className="relative p-[24px] bg-blue-50 items-center flex gap-[8px] lg:min-w-[360px] min-w-full 
                  w-full  sm:flex-row flex-col
                  after:bg-[url(/images/blue-rfp.png)] after:content-[''] after:absolute lg:after:w-[58px] after:w-[44px] lg:after:h-[115px] after:h-[85px] after:max-h-[90%] after:top-0 after:right-0 after:bg-contain after:bg-no-repeat after:bg-right-bottom
                  before:bg-[url(/images/crm/blue-noise.png)] before:backdrop-blur-xs before:content-[''] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-cover before:bg-no-repeat before:bg-center"
                >
                  {/* Icon */}
                  <span className="h-[45px] w-[45px] flex bg-white relative  z-40">
                    <svg
                      width="45"
                      height="45"
                      viewBox="0 0 45 45"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <image
                        width="21"
                        height="21"
                        x="12.5"
                        y="12.5"
                        fill="white"
                        href={
                          baseUrl +
                          data?.buttons?.[0]?.image?.data?.attributes?.url
                        }
                      />
                    </svg>
                  </span>

                  {/* schedule call */}
                  <a
                    href={data?.buttons?.[0]?.href}
                    target="_blank"
                    rel="noreferrer"
                    className="text-subtitle-1 font-bold text-primary-text text-center sm:text-left w-auto relative z-40 sm:pr-[60px]"
                  >
                    {data?.buttons?.[0]?.label}
                  </a>
                </div>
              </div>
            )}

            {/* Green Card */}
            {data?.buttons?.[1]?.href && (
              <div className="h-full flex items-center cursor-pointer sm:w-auto w-full">
                <div className="h-full flex items-center justify-center cursor-pointer sm:w-auto w-full">
                  <div
                    className="relative p-[24px] bg-green-50 items-center flex gap-[8px] 
                    w-full justify-center sm:justify-end sm:flex-row flex-col
                    after:bg-[url(/images/green-rfp.png)] after:content-[''] after:absolute lg:after:w-[58px] after:w-[44px] lg:after:h-[115px] after:h-[85px] after:max-h-[90%] after:top-0 after:right-0 after:bg-contain after:bg-no-repeat after:bg-right-bottom
                    before:bg-[url(/images/crm/green-noise.png)] before:backdrop-blur-xs before:content-[''] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-cover before:bg-no-repeat before:bg-center"
                  >
                    {/* Icon */}
                    <span className="h-[45px] w-[45px] bg-white flex relative z-40">
                      <svg
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <image
                          width="22"
                          height="22"
                          x="12.5"
                          y="11"
                          fill="white"
                          href={
                            baseUrl +
                            data?.buttons?.[1]?.image?.data?.attributes?.url
                          }
                        />
                      </svg>
                    </span>

                    {/* Contact mail */}
                    <a
                      href={`mailto:${data?.buttons?.[1]?.href}`}
                      className="text-heading-6 font-bold text-primary-text text-center sm:text-left w-auto relative z-40 sm:pr-[30px]"
                    >
                      {data?.buttons?.[1]?.label}
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>

          <QuoteForm data={data} />
        </div>
      </div>
    </Section>
  );
};
export default RFPForm;
